import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { CommonModule } from '@angular/common';
import { AfterContentInit, ChangeDetectorRef, Component, ContentChild, Input, inject } from '@angular/core';

import { TerraInputBoolean } from '../../models/terra-input-boolean.models';
import { TerraAvatarComponent } from '../terra-avatar';
import { TerraBadgeModule } from '../terra-badge';

@Component({
  selector: 'terra-notification-card',
  imports: [CommonModule, TerraBadgeModule],
  templateUrl: './terra-notification-card.component.html',
  styleUrl: './terra-notification-card.component.scss',
})
export class TerraNotificationCardComponent implements AfterContentInit {
  private readonly _changeDetectorRef = inject(ChangeDetectorRef);

  @ContentChild(TerraAvatarComponent) private _projectedAvatar?: TerraAvatarComponent;

  /**
   * Shows badge to indicate that the notification is unread.
   * @default false
   */
  @Input() get unread(): boolean {
    return this._unread;
  }
  set unread(value: TerraInputBoolean) {
    this._unread = coerceBooleanProperty(value);
    this._changeDetectorRef.markForCheck();
  }
  private _unread = false;

  ngAfterContentInit(): void {
    if (this._projectedAvatar) {
      this._projectedAvatar.size = 'huge';
    }
  }
}
